import styled from 'styled-components';
import { spacing, color, media, typography } from '~/theme';
import { Heading1, Heading2, Heading3, Heading4 } from '~/theme/headings';

export const OntarioRow = styled.div`
    margin: ${spacing.spacing0} auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    max-width: 22.625rem;

    @media (${media.small}) {
        max-width: 48rem;
    }

    @media (${media.medium}) {
        flex-direction: row;
        max-width: 72rem;
    }
`;

export const OntarioColumn = styled.div`
    width: 100%;
    padding-left: ${spacing.spacing4};
    padding-right: ${spacing.spacing4};
`;

export const TextParagraph = styled.p`
    font-size: inherit;
    line-height: 1.6;
    text-rendering: optimizeLegibility;
    margin: ${spacing.spacing0} ${spacing.spacing0} ${spacing.spacing5} ${spacing.spacing0};

    & + ul {
        margin-top: -${spacing.spacing3};
    }

    & + ${Heading1}, & + ${Heading2}, & + ${Heading3}, & + ${Heading4} {
        margin-top: ${spacing.spacing6};
    }
`;

export const LeadParagraph = styled.p`
    font-size: 20px;
    font-weight: 400;
    line-height: ${typography.lineHeightDefault};
    text-rendering: optimizeLegibility;
    margin: ${spacing.spacing0} ${spacing.spacing0} ${spacing.spacing5} ${spacing.spacing0};

    @media (${media.medium}) {
        font-size: calc(${typography.fontSizeLarge}px + 2px);
        max-width: 70rem;
    }
`;

export const PageDescriptionParagraph = styled(TextParagraph)`
    font-size: ${typography.fontSizeLarge}px;
    line-height: ${typography.defaultLineHeight};
    max-width: none;
`;

export const Figcaption = styled.figcaption`
    color: ${color.hintTextGrey};
    max-width: 48rem;
`;

export const UnorderedList = styled.ul`
    padding: ${spacing.spacing0};
    list-style: disc;
    margin-left: ${spacing.spacing6};

    li {
        padding: ${spacing.spacing0} ${spacing.spacing0} ${spacing.spacing3} ${spacing.spacing0};

        &:last-child {
            padding-bottom: ${spacing.spacing0};
        }
    }

    ul {
        margin: ${spacing.spacing2} ${spacing.spacing0} ${spacing.spacing2} ${spacing.spacing6};
    }

    & + ${Heading1}, & + ${Heading2}, & + ${Heading3}, & + ${Heading4} {
        margin-top: ${spacing.spacing6};
    }

    @media ${media.small} {
        margin: ${spacing.spacing2} ${spacing.spacing0} ${spacing.spacing5} ${spacing.spacing5};

        ul {
            margin: ${spacing.spacing2} ${spacing.spacing0} ${spacing.spacing2} ${spacing.spacing8};
        }
    }
`;

export const HRuler = styled.hr`
    padding: ${spacing.spacing0};
    margin: ${spacing.spacing0};
    border: none;
    border-bottom: 4px solid ${color.palette.greyscale20};
    width: 100%;
`;

export const TextParagraphBold = styled(TextParagraph)`
    font-weight: ${typography.fontWeightBold};
`;

export const Divider = styled.hr`
    border: none;
    border-top: 3px solid ${color.palette.black};
    margin-bottom: ${spacing.spacing5};
`;

export const OntarioIcon = styled.svg`
    display: inline-block;
    width: 24px;
    height: 24px;
    stroke-width: 0;
    stroke: currentColor;
    fill: currentColor;
    vertical-align: middle;
    overflow: hidden;
    margin-bottom: calc(${spacing.spacing1} / 2);
`;

export const BoldText = styled.span`
    font-size: inherit;
    font-weight: ${typography.fontWeightBold};
    line-height: 1.6;
`;
